
(function() {
  var result = { translations: { "en-gb": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en-gb": "static-7.1117"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1117",
    "ar-eg": "static-7.1117",
    "bg": "static-7.1117",
    "bn": "static-7.1117",
    "ca-es": "static-7.1117",
    "cs": "static-7.1117",
    "da": "static-7.1117",
    "de": "static-7.1117",
    "el": "static-7.1117",
    "en-gb": "static-7.1117",
    "en": "static-7.1117",
    "es-mx": "static-7.1117",
    "es": "static-7.1117",
    "et": "static-7.1117",
    "fi": "static-7.1117",
    "fr-ca": "static-7.1117",
    "fr": "static-7.1117",
    "he-il": "static-7.1117",
    "hi": "static-7.1117",
    "hr": "static-7.1117",
    "hu": "static-7.1117",
    "id": "static-7.1117",
    "it": "static-7.1117",
    "ja": "static-7.1117",
    "ko": "static-7.1117",
    "lt": "static-7.1117",
    "ms": "static-7.1117",
    "nl": "static-7.1117",
    "no": "static-7.1117",
    "pl": "static-7.1117",
    "pt-br": "static-7.1117",
    "pt-pt": "static-7.1117",
    "ro": "static-7.1117",
    "ru": "static-7.1117",
    "sk": "static-7.1117",
    "sl": "static-7.1117",
    "sv": "static-7.1117",
    "th": "static-7.1117",
    "tl": "static-7.1117",
    "tr": "static-7.1117",
    "uk": "static-7.1117",
    "vi": "static-7.1117",
    "x-pseudo": "static-7.1117",
    "zh-cn": "static-7.1117",
    "zh-hk": "static-7.1117",
    "zh-tw": "static-7.1117"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en-gb', {version: 'static-7.1117'}); }
})();


